import React from 'react'
import styled from 'styled-components'
import { theme } from 'styled-tools'
import PropTypes from 'prop-types'

const NoBackground = styled.div`
  width: 100vw;
  max-width: 100%;
  background-color: ${theme('contentHeader.backgroundColor')};

  ${(p) => p.theme.media.min.md`
    padding-bottom: 20px;
  `}

  ${(p) =>
    p.showPromo &&
    `
    padding-bottom: 20px;
  `}
  ${(p) =>
    p.showPromo &&
    p.theme.media.min.md`
    padding-bottom: 40px;
  `}
`
const Background = styled.div`
  width: 100vw;
  max-width: 100%;
  background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0)
    ),
    url('${(p) => p.mobileBackground}');
  background-position: center;
  background-size: cover;
  min-height: ${theme('contentHeader.height.mobile')};

  ${(p) => p.theme.media.min.xs`
    min-height: ${theme('contentHeader.height.small')};
  `}

  ${(p) => p.theme.media.min.sm`
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)), url('${
      p.desktopBackground
    }');
    min-height: ${theme('contentHeader.height.desktop')};
  `}

  ${(p) =>
    p.showPromo &&
    `
    padding-bottom: 20px;
  `}
`

const QUALITY = 'q_65,f_jpg'
const WIDTH_DESKTOP = 'w_2560'
const WIDTH_SMALL = 'w_720'

export const formatImageUrl = ({ image, isSmall = false }) => {
  if (!image) {
    return ''
  }
  const width = isSmall ? WIDTH_SMALL : WIDTH_DESKTOP
  return `https://assets.nobiadigital.com/image/${image.type}/c_fit,${width},${QUALITY}/v${image.version}/${image.publicId}`
}

const Header = ({ mobileBackground, desktopBackground, showPromo, children }) =>
  !desktopBackground && !mobileBackground ? (
    <NoBackground showPromo={showPromo}>{children}</NoBackground>
  ) : (
    <Background
      mobileBackground={formatImageUrl({
        image: mobileBackground,
        isSmall: true,
      })}
      desktopBackground={formatImageUrl({ image: desktopBackground })}
      showPromo={showPromo}
    >
      {children}
    </Background>
  )

Header.defaultProps = {
  mobileBackground: null,
  desktopBackground: null,
  showPromo: false,
}

Header.propTypes = {
  mobileBackground: PropTypes.shape({}),
  desktopBackground: PropTypes.shape({}),
  showPromo: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default Header
